import { Injectable, Provider } from '@angular/core'

import { BaseUserSettingsModel } from '@ti/shared/user'

@Injectable()
export class TiUserSettingsModel extends BaseUserSettingsModel {
  protected saveName(value: string) {
    return this.api.ti.user.setName(value)
  }

  protected savePhotoBase64(value: string, contentType: string) {
    return this.api.ti.user.setPhotoBase64(value, contentType)
  }

  protected removePhoto() {
    return this.api.ti.user.removePhoto()
  }
}

export const provideTIUserSettingsModel = (): Provider[] => {
  return [TiUserSettingsModel, { provide: BaseUserSettingsModel, useExisting: TiUserSettingsModel }]
}
